import {
  setCurrentStep,
  setIsUploadedImage,
  uploadTownImagesAsync,
} from "@/store/slices/GlobalSlice";
import { Button, Input, message, Select, Upload, Form, Spin } from "antd";
import FormData from "form-data";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import BtnGreen from "../BtnGreen";
import "./style.scss";

const { Option } = Select;
const { TextArea } = Input;

const limitSize = 5242880; // 5MB

message.config({
  top: 200,
});

const TownUpload = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { mainCategories, isSubmitted } = useSelector(
    (state) => state.globalSlice
  );

  const { control, formState, handleSubmit, reset } = useForm({
    defaultValues: {
      TownForm: [
        { category: undefined, upload: undefined, description: undefined },
      ],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "TownForm",
    category: "",
    upload: "",
    description: "",
  });

  const handleOnClick = async (data) => {
    let isPassedFileSize = true;

    const newFormData = [
      ...data.TownForm.map((item) => ({
        category: item.category,
        description: item.description,
        upload: item.upload,
      })),
    ];

    document.querySelectorAll(".error-message").forEach((item) => {
      item.classList.add("hidden");
    });

    data.TownForm.forEach((item, index) => {
      const isFitExtension = /jpg|jpeg|png/.test(item.upload.file.type);

      if (item.upload.file.size > limitSize) {
        const errorSizeField = document.querySelector(
          `#error-size-row-${index}`
        );
        errorSizeField.classList.remove("hidden");
        isPassedFileSize = false;
        return;
      } else if (!isFitExtension) {
        const errorField = document.querySelector(`#error-row-${index}`);
        errorField.classList.remove("hidden");
        isPassedFileSize = false;
        return;
      }
    });

    if (!isPassedFileSize) return;

    const requestData = new FormData();

    newFormData.forEach((item) => {
      requestData.append("images_description[]", item.description);
      requestData.append("images_main_category_id[]", item.category);
      requestData.append("images[]", item.upload.file.originFileObj);
    });

    setIsLoading(true);
    const responseUpload = await dispatch(uploadTownImagesAsync(requestData));

    if (
      responseUpload.payload["error-code"] != 0 ||
      !responseUpload.payload.house_id
    ) {
      return;
    }

    dispatch(setIsUploadedImage());
    dispatch(setCurrentStep("detail"));
    setIsLoading(false);
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }

    return e && e.fileList;
  };

  const uploadSettings = {
    name: "file",
    valuePropName: "fileList",
    getValueFromEvent: normFile,
  };

  const handleBack = () => {
    dispatch(setCurrentStep(""));
  };

  useEffect(() => {
    if (!isSubmitted) return;
    reset();
  }, [isSubmitted]);

  return (
    <div>
      <span
        className="absolute left-5 top-5 text-lg font-semibold text-sgbc-blue-800 underline cursor-pointer"
        onClick={handleBack}
      >
        {"<"} Back
      </span>

      <div className="mb-8 text-center">
        <h2 className="text-28 leading-10 font-semibold mb-3">
          Step 2: Upload pictures of your green home
        </h2>

        <h3 className="text-lg leading-6">
          Submit up to 5 images and select the category that best fits the
          choices you’ve made.
        </h3>
      </div>

      <div className="form_upload">
        {fields.map((item, index) => {
          return (
            <div
              className="grid md:grid-cols-4 gap-3 pt-8 pb-20 md:pb-8 border-t border-solid border-gray-500"
              key={item.id}
            >
              <figure>
                <Controller
                  render={({ field }) => (
                    <Select
                      {...field}
                      placeholder="Category"
                      style={{ width: "100%" }}
                      className={`${
                        formState.errors.TownForm?.[index]?.category &&
                        "error-field"
                      }`}
                    >
                      {mainCategories?.map((option, index) => (
                        <Option key={index} value={option.id}>
                          {option.name}
                        </Option>
                      ))}
                    </Select>
                  )}
                  rules={{ required: true }}
                  name={`TownForm.${index}.category`}
                  control={control}
                />

                <div style={{ color: "red" }}>
                  {formState.errors.TownForm?.[index]?.category && (
                    <p>Field cannot be empty</p>
                  )}
                </div>
              </figure>

              <figure>
                <Controller
                  render={({ field }) => (
                    <Upload
                      {...field}
                      {...uploadSettings}
                      maxCount={1}
                      className="w-full"
                    >
                      <Button
                        className={`${
                          formState.errors.TownForm?.[index]?.upload &&
                          "error-field"
                        }`}
                      >
                        <div className={`flex justify-between items-center`}>
                          <span className="text-lg font-semibold text-sgbc-black-800">
                            Choose File
                          </span>

                          <img
                            src={require("@/assets/images/upload-icon.png")}
                            alt="icon"
                          />
                        </div>
                      </Button>

                      <h3 className="font-semibold text-sm p-1">
                        Upto 5 MB in jpg or png format
                      </h3>

                      <h3
                        id={`error-size-row-${index}`}
                        className="hidden font-semibold text-xs text-red-500 p-1 error-message"
                      >
                        Uploaded image is larger than 5 MB
                      </h3>

                      <h3
                        id={`error-row-${index}`}
                        className="hidden font-semibold text-xs text-red-500 p-1 error-message"
                      >
                        Only JPG, JPEG & PNG files are allowed
                      </h3>
                    </Upload>
                  )}
                  rules={{ required: true }}
                  name={`TownForm.${index}.upload`}
                  control={control}
                />

                <div style={{ color: "red" }}>
                  {formState.errors.TownForm?.[index]?.upload && (
                    <p>No File Chosen</p>
                  )}
                </div>
              </figure>

              <figure>
                <Controller
                  render={({ field }) => (
                    <TextArea
                      {...field}
                      placeholder="Describe Your Green Choices"
                      rows={4}
                      className={`${
                        formState.errors.TownForm?.[index]?.description &&
                        "error-field"
                      }`}
                    />
                  )}
                  rules={{ required: true }}
                  name={`TownForm.${index}.description`}
                  control={control}
                />

                <div style={{ color: "red" }}>
                  {formState.errors.TownForm?.[index]?.description && (
                    <p>Field cannot be empty</p>
                  )}
                </div>
              </figure>

              {fields.length > 1 && (
                <figure>
                  <BtnGreen
                    className="space-x-5 text-lg font-semibold cursor-pointer w-full"
                    onClick={() => remove(index)}
                  >
                    <span>Remove</span>

                    <span>
                      <img
                        src={require("@/assets/images/closeX.png")}
                        alt="icon"
                      />
                    </span>
                  </BtnGreen>
                </figure>
              )}
            </div>
          );
        })}
      </div>

      {fields.length < 5 && (
        <figure
          className="inline-flex items-center cursor-pointer mb-16 md:mb-0"
          onClick={() => {
            append({});
          }}
        >
          <div className="bg-sgbc-green-500 rounded-full w-50 h-50 flex items-center justify-center mr-3">
            <img src={require("@/assets/images/plus.png")} alt="icon" />
          </div>

          <span className="text-lg text-sgbc-black-700 font-semibold">
            Add more images
          </span>
        </figure>
      )}

      <div className="text-center">
        <BtnGreen
          className="space-x-5 text-lg font-semibold cursor-pointer"
          onClick={handleSubmit(handleOnClick)}
        >
          <Spin spinning={isLoading} />
          <span>Upload & Proceed</span>

          <span>
            <img src={require("@/assets/images/right-arrow.png")} alt="icon" />
          </span>
        </BtnGreen>
      </div>
    </div>
  );
};

TownUpload.propTypes = {};

export default TownUpload;
